import React from "react";

import { faPlus } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ReactComponent as EmptyDashboardIcon } from "assets/dashboard/empty-dashboard.svg";
import { useIntl } from "react-intl";

import { Button } from "@mapmycustomers/ui";

import styles from "./EmptyGrid.module.scss";

interface Props {
  canAddCharts?: boolean;
  onAddChart?: () => void;
}

const EmptyGrid: React.FC<Props> = ({ canAddCharts, onAddChart }) => {
  const intl = useIntl();
  return (
    <div className={styles.emptyContainer}>
      <EmptyDashboardIcon />
      <div className={styles.description}>
        <span className={styles.title}>
          {intl.formatMessage({
            id: "dashboard.grid.empty.title",
            defaultMessage: "You don’t have any charts",
            description: "Empty dashboard title",
          })}
        </span>
        <span>
          {intl.formatMessage({
            id: "dashboard.grid.empty.description",
            defaultMessage: "Add a chart to get performance insights.",
            description: "Empty dashboard description",
          })}
        </span>
      </div>
      {canAddCharts && (
        <Button leftIcon={<FontAwesomeIcon icon={faPlus} />} onClick={onAddChart} type="primary">
          {intl.formatMessage({
            id: "dashboard.grid.empty.addChart",
            defaultMessage: "Add Chart",
            description: "Empty dashboard add chart button",
          })}
        </Button>
      )}
    </div>
  );
};

export default EmptyGrid;
